<template>
  <div>
    <div class="filters">
      <div class="input-group select-cohort">
        <label @click="() => $refs.cohorts.$refs.search.focus()">Cohort:</label>
        <VueSelect
          ref="cohorts"
          v-model="selectedCohort"
          :options="cohortOptions"
          placeholder="Filter by Cohort"
          label="name"
          @input="updateRoute($event, 'cohort_id')"
        />
      </div>
      <div class="input-group">
        <label for="review_state">Review State:</label>
        <select
          id="review_state"
          v-model="reviewState"
          name="review_state"
          class="bg-white border px-1"
          @change="updateRoute($event, 'review_state')"
        >
          <option value="pending" selected>Pending</option>
          <option value="completed">Completed</option>
        </select>
      </div>
      <div class="input-group">
        <label for="author_email">Author:</label>
        <input
          id="author_email"
          v-model="author"
          type="text"
          name="author_name"
          placeholder="Filter by author name"
          @keypress.enter="updateRoute($event, 'author')"
          @change="updateRoute($event, 'author')"
        />
      </div>
      <div class="input-group">
        <label for="reviewer_email">Reviewer:</label>
        <input
          id="reviewer_email"
          v-model="reviewer"
          type="email"
          name="reviewer_email"
          placeholder="Filter by reviewer email"
          @keypress.enter="updateRoute($event, 'reviewer')"
          @change="updateRoute($event, 'reviewer')"
        />
      </div>
      <div class="input-group ml-auto">
        <button
          class="btn__filters--clear hover:text-grey-darkest focus:text-grey-darkest py-2"
          @click="clearFilters"
        >
          Clear Filters
        </button>
      </div>
    </div>

    <hr />

    <Table
      ref="myTable"
      :endpoint="`${siteConfig.siteURL}questions/submissions`"
      :tableConfig="tableConfig"
    />
    <div
      v-if="submissionsLoaded && submissions.length === 0"
      class="mt-12 text-center"
    >
      No Submission found, try changing the filters.
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: {
    VueSelect,
    Table,
  },
  data() {
    return {
      reviewState: "pending", // pending gets priority
      author: "",
      reviewer: "",
      selectedCohort: "",
      cohortOptions: [],
      submissions: [],
      submissionsLoaded: false,
      siteConfig,
      tableConfig: [
        {
          header: {
            textContent: "Review Status",
          },

          path: "review_state",
          classList: "text-red capitalize",
        },
        {
          header: {
            textContent: "Project",
          },
          path: "project.name",
        },
        {
          header: {
            textContent: "Author",
          },
          path: "user.first_name+user.last_name",
        },
        {
          header: {
            sortingParam: "updated_on",
            value: "",
            textContent: "Updated On",
          },
          path: "updated_on",
          type: "date",
        },
        {
          header: {
            textContent: "Reviewer",
          },
          path: "reviewer.first_name+reviewer.last_name",
        },
        {
          header: {
            textContent: "Id",
          },
          path: "id",
        },
        {
          header: {
            textContent: "Action",
          },

          path: "id",
          type: "action",
          actionButtonText: "Review",
          routePath: "/review-submissions/:submissionId",
        },
      ],
    }
  },
  created() {
    // push default query params for better url
    if (!this.$route.query || Object.keys(this.$route.query).length === 0) {
      const searchParams = new URLSearchParams(
        "review_state=pending&sort_by=-updated_on&page=1&per_page=20"
      )
      const newRouteObj = { ...this.$route, query: { ...this.$route.query } }
      searchParams.forEach((value, key) => {
        newRouteObj.query[key] = value
      })
      this.$router.replace(newRouteObj)
    }
    this.getCohorts()
  },
  methods: {
    updateRoute(evt, key) {
      const data = { key }
      if (evt) {
        if (evt.target) {
          data.value = evt.target.value
        } else {
          data.value = evt.id
        }
      }
      this.$refs.myTable.updateRoute(data)
    },
    clearFilters() {
      this.reviewer = ""
      this.author = ""
      this.selectedCohort = ""
      this.reviewState = "pending" // default
      const data = [
        { key: "reviewer" },
        { key: "author" },
        { key: "cohort_id" },
        { key: "review_state", value: this.reviewState },
      ]
      this.$refs.myTable.updateRoute(data)
    },
    getCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const cohorts = res.data.items
        this.cohortOptions = cohorts.map(item => ({
          id: item.id,
          name: item.name,
        }))
        /* if cohort_id is present in route, select that cohort */
        if (this.$route.query && this.$route.query.cohort_id) {
          const { cohort_id } = this.$route.query
          const cohort = this.cohortOptions.find(c => c.id === cohort_id)
          if (cohort && cohort.id) {
            this.selectedCohort = cohort
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.warning,
.success,
.error {
  display: inline-block;
  margin-bottom: 0.25rem;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
  color: white;
  font-size: 0.8rem;
}

.warning {
  background: orange;
}
.success {
  background: #01bb01;
}

.error {
  background: #e91e63;
}

.desc:focus,
.desc:active {
  outline: 2px solid #1d1d20;
}

.filters {
  display: flex;
  align-items: flex-end;
}

.filters > * {
  margin-right: 1rem;
}

.pagination {
  display: flex;
  align-items: center;
}

.pagination a {
  display: inline-block;
  width: 3ch;
  height: 3ch;
  margin-right: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  line-height: 3ch;
  text-align: center;
  vertical-align: middle;
}

.pagination a.btn {
  width: auto;
  height: 3.5ch;
  padding: 0 0.75rem;
  line-height: 3.5ch;
}

.ml-auto {
  margin-left: auto;
}

.btn__filters--clear,
.btn__filters--apply {
  display: block;
  width: 100%;
  border-radius: 4px !important;
}

.btn__filters--apply {
  font-size: 0.9em;
  line-height: 2rem;
}

.btn__filters--clear {
  margin-bottom: 0.5rem;
  padding: 0.2rem 0;
  border: none;
  background: white;
  box-shadow: none;
  text-decoration: underline;
}

label + * {
  margin-top: 2px !important;
}

.select-cohort {
  min-width: 15rem;
  max-width: 25rem;
}
</style>
